import Util from "./_parts/Util.js";
import Scroll from "./_parts/Scroll.js";
import Menu from "./_parts/Menu.js";
import Slider from "./_parts/Slider.js";
import Resize from "./_parts/Resize.js";
import Cart from "./_parts/Cart.js";
import Hover from "./_parts/Hover.js";
import Page from "./_parts/Page.js";
import Filter from "./_parts/Filter.js";
//
import { gsap } from "./_parts/Util.js";

class App extends Util {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.getPage();
    this.common();
    this.fadeIn();
    this.fadeOut();
  }

  fadeIn() {
    gsap.to(document.body, {
      opacity: 1,
      duration: 0.2,
      delay: 0.6,
    });
  }

  fadeOut() {
    document.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", function (e) {
        const blank = this.target === "_blank";
        const isAnchor = this.classList.contains("anchor");
        if (e.metaKey || e.ctrlKey) {
          return;
        }

        if (!blank && !isAnchor) {
          e.preventDefault();

          let href = this.getAttribute("href");
          gsap.to(document.body, {
            opacity: 0,
            duration: 0.2,
            onComplete: () => {
              location.href = href;
            },
          });
        }
      });
    });
  }

  common() {
    window.SCROLL_INSTANCE = new Scroll();
    window.MENU_INSTANCE = new Menu();
    window.RESIZE_INSTANCE = new Resize();
    window.HOVER_INSTANCE = new Hover();
    window.SLIDER_INSTANCE = new Slider();
    window.PAGE_INSTANCE = new Page();
    window.FILTER_INSTANCE = new Filter();
    window.CART_INSTANCE = new Cart();

    window.addEventListener("popstate", function (event) {
      location.reload();
    });

    window.addEventListener("pageshow", function (event) {
      if (event.persisted) {
        console.log("履歴キャッシュから復元されました");
        location.reload();
      }
    });
  }
}

gsap.delayedCall(0.1, () => {
  window.APP_INSTANCE = new App();
});

export default App;
